import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  number: '01',
  title: 'Descarga el Protocolo',
  description: 'Recibe el PDF inmediatamente en tu correo.'
}, {
  number: '02',
  title: 'Limpia el Incendio',
  description: 'Sigue los primeros 7 días de rescate para deshincharte.'
}, {
  number: '03',
  title: 'Sana y Mantén',
  description: 'Implementa los hábitos de reconstrucción para que la inflamación no vuelva jamás.'
}];
export function HowItWorks() {
  return <section className="py-16 md:py-28 bg-sage-700 text-white relative overflow-hidden" data-id="element-255">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-256">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-white blur-[100px]" data-id="element-257"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-sage-300 blur-[100px]" data-id="element-258"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-259">
        <FadeIn data-id="element-260">
          <div className="text-center mb-16" data-id="element-261">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-262">
              Cómo funciona
            </h2>
            <p className="text-sage-200 text-lg max-w-2xl mx-auto font-sans" data-id="element-263">
              Un proceso simple y guiado paso a paso.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-264">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-sage-500/50 z-0" data-id="element-265"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-266">
              <div className="flex flex-col items-center text-center" data-id="element-267">
                <div className="w-24 h-24 rounded-full bg-sage-600 border-4 border-sage-700 shadow-[0_0_0_4px_rgba(168,207,192,0.2)] flex items-center justify-center mb-6 relative" data-id="element-268">
                  <span className="text-3xl font-serif font-bold text-sage-200" data-id="element-269">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-bold mb-3 font-sans" data-id="element-270">
                  {step.title}
                </h3>
                <p className="text-sage-200 leading-relaxed" data-id="element-271">
                  {step.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}